var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldCheckLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 .833 6.847 1.522a.833.833 0 0 1 .653.813v8.323a5 5 0 0 1-2.226 4.16L10 19.167 4.726 15.65A5 5 0 0 1 2.5 11.49V3.168c0-.39.271-.728.653-.813L10 .833Zm0 1.708L4.167 3.837v7.654c0 1.114.557 2.155 1.484 2.773l4.349 2.9 4.349-2.9a3.333 3.333 0 0 0 1.484-2.773V3.837L10 2.54Zm3.71 4.31 1.18 1.179-5.303 5.303L6.05 9.798l1.179-1.179 2.356 2.357 4.125-4.124Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckLine);
export default __webpack_public_path__ + "static/media/shield-check-line.eea8999b8252e1eb13eb1dc2347ba3ac.svg";
export { ForwardRef as ReactComponent };